import styled from 'styled-components';
import { ReportsZeroState } from 'ui/illustrations';
import { useTranslation } from '../hooks';
import { InsightType } from '../domain';

const Wrapper = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  align-items: center;
  display: flex;
  flex-direction: column;
  height: ${({ theme }) => theme.spacing.utils.pxToRem(148)};
  margin-bottom: ${({ theme }) => theme.spacing.values.plusThreeQuarter};
  row-gap: ${({ theme }) => theme.spacing.values.quarter};
`;

const Title = styled.div`
  ${({ theme }) => theme.styles.subtitles.subtitle1}
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const DATA_TEST = {
  wrapper: 'empty-data-wrapper',
};

export const EmptyData = ({ type }: { type?: InsightType }) => {
  const { t } = useTranslation();
  const placeholderTitle =
    type === InsightType.behavioral ? t('insights.empty.event') : t('insights.empty.data');

  return (
    <Wrapper data-test={DATA_TEST.wrapper}>
      <ReportsZeroState />
      <Title>{placeholderTitle}</Title>
      <Subtitle>{t('insights.empty.expand')}</Subtitle>
    </Wrapper>
  );
};
